<template>
    <div ref="map" class="Map">   
        <GmapMap
            v-if="ready == true"
            language = "ar"
            :options="{
                zoomControl: false,
                fullscreenControl: false,
                center: location,
                mapTypeControl: false,
                streetViewControl: false,
                zoom: zoom,
                restriction: { latLngBounds: bounds, strictBounds: false },
                styles:[

                    // {'elementType':'geometry','stylers':[{'color':'#eeeeee'}]},

                    {'elementType':'labels.icon','stylers':[{'visibility':'off'}]},
                    {'featureType':'transit','stylers':[{'visibility':'on'}, {'color':'#a1a1a1'}]},
                    {'elementType':'labels.text.fill','stylers':[{'color':'#616161'}]},
                    {'elementType':'labels.text.stroke','stylers':[{'color':'#f5f5f5'}]},
                    
                    {'featureType':'administrative.land_parcel','elementType':'labels.text.fill','stylers':[{'color':'#bdbdbd'}]},   

                    {'featureType':'poi','elementType':'geometry','stylers':[{'color':'#d9e3dd'}]}, 
                    // {'featureType':'poi','elementType':'labels.text.fill', 'stylers':[{'visibility':'off'}]},

                    // {'featureType':'poi.park', 'stylers':[{'color':'#616161'}]},
                    {'featureType':'poi.sports_complex', 'stylers':[{'color':'#dcdcdc'}]},

                    // {'featureType':'poi.park','elementType':'labels.text.fill','stylers':[{'visibility':'off'}]},

                    {'featureType':'road','elementType':'geometry','stylers':[{'color':'#ffffff'}]},
                    {'featureType':'road.arterial','elementType':'labels.text.fill','stylers':[{'color':'#757575'}]},
                    {'featureType':'road.highway','elementType':'geometry','stylers':[{'color':'#dadada'}]},
                    {'featureType':'road.highway','elementType':'labels.text.fill','stylers':[{'color':'#616161'}]},
                    {'featureType':'road.local','elementType':'labels.text.fill','stylers':[{'color':'#9e9e9e'}]},
                    {'featureType':'transit.line','elementType':'geometry','stylers':[{'color':'#e5e5e5'}]},
                    {'featureType':'transit.station','elementType':'geometry','stylers':[{'color':'#eeeeee'}]},

                    // #dcdcdc
                    {'featureType':'landscape','elementType':'geometry','stylers':[{'color':'#dcdcdc'}]},
                    {'featureType':'poi.park','elementType':'geometry','stylers':[{'color':'#dcdcdc'}]},

                    // #919191

                    {'featureType':'water','elementType':'geometry','stylers':[{'color':'#919191'}]},
                    {'featureType':'water','elementType':'labels.text.fill','stylers':[{'color':'#ffffff'}]},
                    {'featureType':'road.local.trail','elementType':'geometry','stylers':[{'color':'#919191'}]}

                ]
            }"
            :style="getStyle()"
            ref="mapRef">
            <GmapMarker
                v-for="(m, index) in markers"
                :key="index"
                :ref="'marker_'+ m.id"
                :position="{ lat: m.pos[0], lng: m.pos[1] }"
                :clickable="true"
                :draggable="false"
                @click="onClick(m)"
                :icon="{ url: require('@/commons/img/'+ m.icon)}"/>
        </GmapMap>

        <transition name="Map__button">
            <div class="Map__button" :class="{ 'fr': lang == 'fr' }" v-html="trans('GLOBAL.select')" v-if="!used"/>
        </transition>
    </div>
</template>

<script>

import Coords from '@/config/Coords.js'
import gsap from "gsap"

export default {

    name: 'Map',
    data: ()=>({

        map: null,
        ready: false,
        myCoordinates: {
            lat: 45.505331312,
            lng: -73.55249779
        },
        location: { lat: 45.50874199974399, lng: -73.565000059435331 },
        zoom: 14,
        loop: 0,
        used: false,
        markers: Coords.markers, 
        bounds: {
            north: 46,
            south: 45,
            west: -73.86,
            east: -73.45,
        }
    }),

    computed: {
        geo() { return this.$store.getters['app/geo'] },
        artwork_used() { return this.$store.getters['app/artwork_used'] },
    },

    watch: {
        artwork_used(nw, od) {
            if(nw == null)
                this.showMarkers()
        },
    },

    mounted() {
        this.ids = [ 20, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210 ]
        this.markers[0].pos = [this.geo[0], this.geo[1]]
        this.ready = true
        this.$nextTick(()=>{
            gsap.from(this.$refs['marker_500'], { duration: 1, opacity: 0, repeat: -1, yoyo: true })
            if(this.$route.params.id) {
                let marker = null
                _.each(this.markers, (o)=> { 
                    if(o.uri == this.$route.params.id)
                        gsap.delayedCall(1, ()=>{ this.onClick(o) })      
                })       
            }
        })
    },
    methods: { 
        getStyle() {
            return 'width:'+ window.innerWidth +'px; height:'+ window.innerHeight +'px;'
        },
        onClick(arg) {
            if(arg.type == undefined)
                return
            this.used = true
            this.$refs.mapRef.panTo({ lat: arg.pos[0], lng: arg.pos[1] })
            this.$store.commit('app/SET_ARTWORK', arg.id)
            this.$router.push({ params: { id: arg.uri }})
            gsap.to('.vue-map', { duration: 1, top: '-75vh' })
            this.hideMarkers(arg.id)
        },
        showMarkers() {
            _.each(this.ids, (id)=>{
                gsap.to(this.$refs['marker_'+ id], { duration: .35, opacity: 1 })
            })  
        },
        hideMarkers(_id) {
            _.each(this.ids, (id)=>{
                if(id != _id) {
                    gsap.to(this.$refs['marker_'+ id], { duration: .35, opacity: .2 })
                }
            })
        },

        // getLocation() {
        //     this.$getLocation({})
        //         .then(coord => {
        //             let pos = { lat: coord.lat, lng: coord.lng }
        //             // this.location = pos
        //             this.ready = true
        //         })
        //         .catch(error => alert(error))
        // },

        onLoop(timestamp) {
            // this.loop += 1
            // this.getLocation()
            // TweenMax.delayedCall(5, ()=> this.$raf = window.requestAnimationFrame(this.onLoop))  
        }
    }
}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Map   
    display flex
    position fixed 
    top 0 
    left 0

    &__button 
        position absolute
        top 10%
        left 50%
        transform translateX(-50%)
        font-family Ringside
        font-size 12px
        padding 12px 24px 14px
        border-radius 24px
        background rgba(#411722, .7)
        background linear-gradient(125deg, rgba(65,23,34,.85) 0%, rgba(163,187,196,.85) 100%)
        color white
        width 162px
        text-align center
        transition opacity .25s, transform .25s
        transform translate(-50%, 0)
        &-enter
        &-leave-active
            opacity 0
            transform translate(-50%, -20px)
            transition-delay .35s

        &.fr 
            width 186px

    
</style>














